var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lk-cascader',{attrs:{"transfer":true,"disabled":_vm.disabled,"data":_vm.list,"load-data":_vm.loadData,"value":_vm.val},on:{"on-change":_vm.hanleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }